<template>
  <div class="row">
    <div class="col-12 form-group form-group-sm">
      <label class="label">Cobranzas</label>
      <div class="card">
        <div class="card-body">
          <div v-if="clienteCargado" class="container">
            <div class="row">
              <div class="col-12 form-group form-group-sm">
                <label class="label" for="idCobranzaLugarDePago"
                  >Lugar Cobranzas</label
                >
                <SelectorLugarCobranza v-model="idCobranzaLugarDePago" />
              </div>
            </div>
            <div class="row" v-if="this.tarjeta">
              <ModificarTarjetaForm
                :idCobranzaLugarDePago="idCobranzaLugarDePago"
              />
            </div>
            <div class="row" v-if="this.codigoRapipago">
              <ModificarCodigoRapipago
                :idCobranzaLugarDePago="idCobranzaLugarDePago"
              />
            </div>
            <div class="row">
              <div class="col-12 form-group form-group-sm">
                <label class="label" for="idClienteReferenciador"
                  >Cliente referenciado por</label
                >
                <SelectorClienteVigente
                  v-model="idClienteReferenciador"
                  placeholder="Seleccione cliente referenciador"
                />
              </div>
            </div>
          </div>
          <div v-else>Cargando...</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectorClienteVigente from "../shared/SelectorClienteVigente.vue";
import SelectorLugarCobranza from "../shared/SelectorLugarCobranza.vue";
import ModificarTarjetaForm from "../ModificarCliente/ModificarTarjetaForm.vue";
import ModificarCodigoRapipago from "./ModificarCodigoRapipago.vue";

export default {
  name: "ModificarCobranzasForm",
  data: () => ({ tarjeta: false, codigoRapipago: false }),
  components: {
    SelectorClienteVigente,
    SelectorLugarCobranza,
    ModificarTarjetaForm,
    ModificarCodigoRapipago,
  },
  computed: {
    clienteId() {
      return this.$route.params.id_cliente;
    },
    clienteCargado() {
      return this.$store.state.clientes.ModificarCliente.clienteCargado;
    },
    idCobranzaLugarDePago: {
      get() {
        return this.$store.state.clientes.ModificarCliente
          .idCobranzaLugarDePago;
      },
      set(val) {
        this.$store.commit(
          "clientes/ModificarCliente/setIdCobranzaLugarDePago",
          val,
        );
      },
    },

    idClienteReferenciador: {
      get() {
        return this.$store.state.clientes.ModificarCliente
          .idClienteReferenciador;
      },
      set(val) {
        this.$store.commit(
          "clientes/ModificarCliente/setIdClienteReferenciador",
          val,
        );
      },
    },
  },
  watch: {
    idCobranzaLugarDePago(val) {
      if (val && val.id_ubicacion_dinero) {
        switch (val.id_ubicacion_dinero) {
          case 29: // tarjeta de credito
            this.$store.commit("clientes/ModificarCliente/setTipoTarjeta", "C");
            this.$store.commit(
              "clientes/ModificarCliente/setCodigoRapipago",
              null,
            );
            this.tarjeta = true;
            this.codigoRapipago = false;
            break;
          case 48: // tarjeta de debito
            this.$store.commit("clientes/ModificarCliente/setTipoTarjeta", "D");
            this.$store.commit(
              "clientes/ModificarCliente/setCodigoRapipago",
              null,
            );
            this.tarjeta = true;
            this.codigoRapipago = false;
            break;
          case 33: // rapipago
            this.codigoRapipago = true;
            this.tarjeta = false;
            this.$store.commit(
              "clientes/ModificarCliente/setTipoTarjeta",
              null,
            );
            this.$store.commit("clientes/ModificarCliente/setNroTarjeta", null);
            break;
          default:
            this.tarjeta = false;
            this.codigoRapipago = false;
            this.$store.commit(
              "clientes/ModificarCliente/setTipoTarjeta",
              null,
            );
            this.$store.commit(
              "clientes/ModificarCliente/setCodigoRapipago",
              null,
            );
            this.$store.commit("clientes/ModificarCliente/setNroTarjeta", null);
            break;
        }
      }
    },
  },
};
</script>

<style scoped></style>
